import React from 'react'

const ArrowUp = ({ color, ...props }) => {
  return (
    <svg
      {...props}
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="20" rx="2" fill="#F05A26" />
      <g transform="translate(7,7)">
        <path d="M10 5L5 -4.37114e-07L0 5L10 5Z" fill="white" />
      </g>
    </svg>
  )
}

export default ArrowUp
